import { RequestService } from '@tcc-online/request-service';
import { StorageService } from '../../services';
import ImportProcess from '../../common/types/ImportProcess';

const ImportService = {
    confirmImport,
    cancelImport,
    getImportProgress,
    saveImportId,
    getImportId,
    deleteImportId,
};

const IMPORT_ERROR_MSG = 'nepodarilo se importovat soubor';
const IMPORT_USER_ERROR_MSG = 'nepodarilo se importovat uzivatele';

async function confirmImport(importId: number) {
    const result = await RequestService.post<unknown, ImportProcess>(
        `/imports/${importId}/confirm`,
    );

    if (result.data?.errors?.length) {
        const msg =
            (result.data.errors as { message?: string }[])?.[0]?.message ??
            IMPORT_ERROR_MSG;
        throw new Error(msg);
    }

    return result;
}

async function cancelImport(importId: number) {
    const result = await RequestService.post(`/imports/${importId}/cancel`);

    deleteImportId();

    return result;
}

async function getImportProgress(importId: number) {
    const result = await RequestService.get(`/imports/${importId}`);

    const data = result.data as {
        errors?: unknown[];
        status?: string;
    };
    if (data?.errors?.length) {
        const msg =
            (data.errors as { message?: string }[])?.[0]?.message ??
            IMPORT_USER_ERROR_MSG;
        throw new Error(msg);
    }

    return result;
}

const IMPORT_KEY = 'TCC_ONLINE__IMPORT_ID';

function saveImportId(importId: number) {
    StorageService.setLocal(IMPORT_KEY, importId);
}

function getImportId(): number | null {
    return StorageService.getLocal<number | null>(IMPORT_KEY, null);
}

function deleteImportId() {
    StorageService.deleteLocal(IMPORT_KEY);
}

export default ImportService;
